window.loadWishlist = () => {
    if (!user) return;
    $('#CheckShortlistFixedButton').show();
    mainApiAxios.get('/wishlists')
        .then(function (res) {
            let response = res.data;

            if (response.code === 'OK') {
                // onChangePreferredModalHomepage(response);
                let wishlists = response.data;
                if (!Array.isArray(wishlists)) {

                    wishlistHTML = '';
                    displayWishlist(wishlists);
                    return;
                }
                wishlists.map(function (item) {
                    item.school_url = `${APP_URL}/schools/redirect-${item.code}`;
                    return item;
                });
                displayWishlist(wishlists);
                updateShortlistIconOnPage(wishlists);
            }
        });
}

window.displayWishlist = (wishlists) => {
    let shortlistResponseWrapper = $('#shortlisted-schools-list');
    shortlistResponseWrapper.empty();
    UpdateShortlistCount(wishlists.length);
    if (Object.keys(wishlists).length === 0) {
        const EmptyWishlistHTML = `
                    <div class="empty-shortlist-block text-center empty-aside-block">
                        <h2 class="empty-short">Empty Shortlists</h2>
                        <p class="empty-short-tex">You have no schools in your shortlists. Start adding!</p>
                    </div>`;
        shortlistResponseWrapper.addClass('d-flex align-items-center').append(EmptyWishlistHTML);
        $('#shortlist').find('a').html('<i class="fa fa-heart-o wishlist-heart"></i> (0)');
        return;
    } else {
        shortlistResponseWrapper.removeClass('d-flex align-items-center')
    }

    for (let i = 0; i < wishlists.length; i++) {
        const wishlist = wishlists[i];
        const wishlistSchoolData = wishlist.school_data;

        const boardsArr = [];

        if(wishlistSchoolData.board1) boardsArr.push(wishlistSchoolData.board1_data.board);
        if(wishlistSchoolData.board2) boardsArr.push(wishlistSchoolData.board2_data.board);

        let boardArrStr = '';
        if(boardsArr.length) boardArrStr = boardsArr.join(', ');

        if (!wishlist) break;

        let from = {
            lat: latitude ?? '',
            lng: longitude ?? ''
        };
        let to = {
            lat: wishlistSchoolData.slat,
            lng: wishlistSchoolData.slon,
        };
        let distance = calculateDistance(from, to);
        const school_url = `${APP_URL}/schools/redirect-${wishlistSchoolData.code}/?utm_source=shortlist`;
        //const admissionURL = window.location.origin + '/schools/redirect-' + wishlist.code + '/admission';
        const wishlistHTML = `<div class="package-grid-shortlist position-relative aside-school-card" data-school="${wishlist.school}" >
                                        <div class="aside-school-image">
                                            <a target="_blank"
                          	                   class="d-block w-100 h-100 shortlist-school-image-wrapper aside-school-image-wrapper"
                          	                   href="${school_url}">
                                                <img src="${wishlistSchoolData.galleryImagesThumbs[0] ?? 'https://fakeimg.pl/300x300?text=Edustoke'}"
                                                     class="aside-school-image shortlisted-image w-100 h-100 lazyload"
                                                     alt="${wishlistSchoolData.name}">
                                            </a>
                                            <span class="d-inline-block distance">${distance_condition(distance)}</span>
                                            <div class="d-none">
                                                ${(wishlist.shortlist_by_role === 'counsellor') ? `<span class="counsellor-text-popup">Counsellor</span>` : ``}
                                            </div>
                                        </div>
                                        <div class="shortlisted-content aside-school-content">
                                            <div class="shortlist-school-name aside-school-primary-data">
                                                <h3 class="school-name mt-0">
                                                    <a href="${school_url}" class="text-decoration-none">${(wishlistSchoolData.name).toLowerCase()}</a>
                                                </h3>
                                                <span class="school-address d-flex">
                                                    <i class="fa fa-map-marker pe-2"></i>
                                                  ${(wishlistSchoolData.address1) ? wishlistSchoolData.address1.toLowerCase() : ''}
                                                </span>
                                                <div class="info-tags">
                                                    <span class="tags-list ${(wishlistSchoolData.typeid === 2) ? 'hidden' : ''}">
                                                        <span>Board</span>
                                                        <span>${boardArrStr}</span>
                                                    </span>
                                                        <span class="tags-list">
                                    	                    <span>${parseInt(wishlistSchoolData.typeid) === 2 ? 'Monthly' : 'Annual'} Fees</span>
                                    	                    <span>${get_fee_with_unit(wishlist.school_data)}</span>
                                                        </span>
                                                        <span class="tags-list ${!wishlistSchoolData.admission_start_date ? 'hidden' : ''}">
                                    	                    <span>Admission Date</span>
															<span>${wishlistSchoolData.admission_start_date}</span>
														</span>
                                                </div>
                                            </div>
                                            <div class="school-comment-popup ${!wishlistSchoolData.comment ? 'd-none' : ''}">${!!wishlistSchoolData.comment ? wishlistSchoolData.comment : ''}</div>
                                                ${(wishlistSchoolData.vad === 1) ?
                                                    `<div class="review-text questionSlickPopup visit-school-wrapper d-none">
                                                        <div class="review-text-line visit-school-container">
                                                            <span class="question-text">Do you wish to visit this school?</span>
                                                            <div class="answer-block">
                                                                <span class="true-answer ${(wishlistSchoolData.question1 === 1) ? 'active' : ''}" data-question="question1">Yes</span>
                                                                <span class="false-answer ${(wishlistSchoolData.question1 === 0) ? 'active' : ''}" data-question="question1">No</span>
                                                            </div>
                                                        </div>
                                                    </div>

													<div class="datetimeBlockPopup appointment-wrapper position-relative d-none" ${!wishlistSchoolData.question1 ? 'style="display:none"' : ''}>
														<span class="appointment-message">Please select visit date & time</span>
															<input type="text"
													    			name="dateTimesPopup"
																	value="${getDateFormatShortlist(wishlistSchoolData.srm_follow_up_At)}"
																	class="form-control dateTimePopup fixed-appointment" />
													</div>` : ``}

                                                    <div class="school-feedback-wrapper d-none">
													    <div class="emoji-group feedback-controls-wrapper d-flex">
														    <button class="emo-block short-like-block-popup ${(wishlist.like === 1) ? 'active' : ' '}" data-like-val="1">
															    <i class="fa fa-thumbs-up"></i><span> Interested</span>
															</button>
															<button class="emo-block short-dislike-block-popup ${(wishlist.like === 0) ? 'active' : ' '}" data-like-val="0">
															    <i class="fa fa-thumbs-down"></i><span> Not Interested</span>
															</button>
															<a href="tel:${(wishlistSchoolData.counsellor_phone == null) ? wishlistSchoolData.phone1 : wishlistSchoolData.counsellor_phone}" class="text-unset">
															    <i class="fa fa-phone"></i><span> Call</span>
															</a>
														</div>
                                                    </div>
                                        </div>
									    <span class="d-inline-block remove-shortlist">Remove</span>
                                    </div>`;

        shortlistResponseWrapper.append(wishlistHTML);
    }
    if (wishlists.length > 0) {

        //shortlistPopupQuestionSlick(); // Initialize Slick Question
        InitShortlistQuestionsPopup(); // shortlist question click bind Yes or no state changes
        likeDislikeInitPopup(); // like dislike question click bind
        DateRangeInitPopup(); // Date Range Initialize with Date time edit button
        ToggleReadMore(); // Read More Read Less comment

        $('#shortlisted-schools-list .remove-shortlist').on('click', function (e) {
            let wishlist_el = $(this).closest('.package-grid-shortlist');
            const school_id = $(wishlist_el).attr('data-school');
            removeWishlist(school_id, function (success) {

                loadWishlist();
            });
        });

        // show count with wishlist menu
        const wishlist_count = wishlists.length;
        $('#shortlist').find('a').html('<i class="fa fa-heart-o wishlist-heart"></i> (' + wishlist_count + ')');
        $('#CheckShortlistFixedButton').find('.count-shortlists').html(wishlist_count);
    }


}


window.UpdateShortlistCount = (wishListCount) => {
    let shortlistCount = $('.count-shortlists');
    if (!!wishListCount && wishListCount === 0) {
        shortlistCount.hide();
    } else {
        shortlistCount.text(wishListCount);
        shortlistCount.show();
    }
}

window.getDateFormatShortlist = (date) => {
    if (date == null) return moment(new Date()).format('DD/M | hh:mm A');
    return moment(date).format('DD/M | hh:mm A');
}

window.calculateDistance = (from, to) => {
    if (from && to) {
        let fromLat = from.lat;
        let fromLng = from.lng;
        let toLat = to.lat;
        let toLng = to.lng;

        let fromRadLat = Math.PI * fromLat / 180;
        let toRadLat = Math.PI * toLat / 180;
        let theta = fromLng - toLng;
        let radTheta = Math.PI * theta / 180;
        let dist = Math.sin(fromRadLat) * Math.sin(toRadLat) + Math.cos(fromRadLat) * Math.cos(toRadLat) * Math.cos(radTheta);

        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        dist = dist.toFixed(2);
        dist = dist + " kms";
        return dist
    }
};

window.InitShortlistQuestionsPopup = () => {

    $('#shortlisted-schools-list .true-answer').click(function () {
        let schoolVisitResponseBtn = $(this);
        if (schoolVisitResponseBtn.hasClass('active')) return;

        schoolVisitResponseBtn.addClass('active').next().removeClass('active');
        schoolVisitResponseBtn.parent().find('.black-tick').hide(); // hide tick in button No
        schoolVisitResponseBtn.find('.white-tick').show(); // show tick in button Yes
        let school = schoolVisitResponseBtn.closest('.package-grid-shortlist').attr('data-school');
        let question = schoolVisitResponseBtn.closest('.answer-block').find('.true-answer').attr('data-question');
        if (question === 'question1') {
            schoolVisitResponseBtn.closest('.package-grid-shortlist').find('.datetimeBlockPopup').show();
        }
        let questionValue = 1;
        updateQuestionAjaxPopup(school, question, questionValue);
        if (question !== 'question3') { // Do not slider after Question 3
            schoolVisitResponseBtn.parent().parent().parent().parent().parent().find('.slick-next').trigger('click');
        }
    });

    $('#shortlisted-schools-list .false-answer').click(function () {
        let schoolVisitResponseBtn = $(this);

        if (schoolVisitResponseBtn.hasClass('active')) return;

        schoolVisitResponseBtn.addClass('active').prev().removeClass('active');
        schoolVisitResponseBtn.parent().find('.white-tick').hide(); // show tick in button Yes
        schoolVisitResponseBtn.find('.black-tick').show(); // hide tick in button No
        let school = schoolVisitResponseBtn.closest('.package-grid-shortlist').attr('data-school');
        let question = schoolVisitResponseBtn.closest('.answer-block').find('.true-answer').attr('data-question');
        if (question === 'question1') {
            schoolVisitResponseBtn.closest('.package-grid-shortlist').find('.datetimeBlockPopup').hide();
        }
        let questionValue = 0;
        updateQuestionAjaxPopup(school, question, questionValue);
        if (question !== 'question3') { // Do not slide after Question 3
            schoolVisitResponseBtn.parent().parent().parent().parent().parent().find('.slick-next').trigger('click');
        }
    });
}

window.updateQuestionAjaxPopup = (schoolId, question, value) => {

    $.ajax({
        type: "GET",
        url: HOST + "/home/wishlist-new/server/short-question-update.php",
        data: {school: schoolId, question: question, value: value},
        success: function (data) {
            if (DEBUG) console.log(data);
        },
        error: function (data) {
            if (DEBUG) console.log(data);
        }
    })
}

window.likeDislikeInitPopup = () => {
    $('.short-like-block-popup,.short-dislike-block-popup').on('click', function () {
        let _self = this;
        let school = $(this).closest('.package-grid-shortlist').attr('data-school');
        let likeVal = $(this).attr('data-like-val');
        likeDislikeTextChangesPopup(likeVal, _self);
        updateLikeShortlistAjaxPopup(school, likeVal);
    })
}

window.likeDislikeTextChangesPopup = (val, elem) => {
    if (val === '1') {
        $(elem).parent().find('.short-dislike-block-popup').removeClass('active');
        $(elem).addClass('active');

    } else {
        $(elem).parent().find('.short-like-block-popup').removeClass('active');
        $(elem).addClass('active');

    }
}

window.updateLikeShortlistAjaxPopup = (schoolId, likeVal) => {
    $.ajax({
        type: "GET",
        url: HOST + "/home/wishlist-new/server/update-short-like-status.php",
        data: {school: schoolId, like: likeVal},
        success: function (data) {
            if (DEBUG) console.log(data);
        },
        error: function (data) {
            if (DEBUG) console.log(data);
        }
    })
}

window.DateRangeInitPopup = () => {

    $('input[name="dateTimesPopup"]').daterangepicker({
        parentEl: '.datetimeBlockPopup',
        singleDatePicker: true,
        drops: 'up',
        opens: 'center',
        timePicker: true,
        minDate: moment().startOf('hour'),
        locale: {
            format: 'DD/M | hh:mm A'
        }
    });

    $('.dateTimePopup').on('apply.daterangepicker', function (ev, picker) {
        let date = picker.startDate.format('DD/M | hh:mm A');
        $(this).closest('.package-grid-shortlist').find('.walkin-date-time-popup').text(date);
        let schoolId = $(this).closest('.package-grid-shortlist').attr('data-school');
        wishToVisitSchoolDateTimeHome(schoolId, picker.startDate.format('DD-MM-YYYY hh:mm A'));
        // $(this).closest('.package-grid-shortlist').find('.datetimeBlockPopup').hide();
        // $(this).closest('.package-grid-shortlist').find('.walkin-date-time-block-popup').show();
    });

    walkinDateEditPopupInit();

}

window.wishToVisitSchoolDateTimeHome = (schoolId, datetime) => {
    $.ajax({
        type: 'POST',
        data: {school: schoolId, datetime: datetime},
        url: HOST + '/home/wishlist-new/server/school-visited-date-time.php',
        success: function (data) {
            if (DEBUG) console.log(data);
        }, error: function (data) {
            if (DEBUG) console.log(data);
        }
    })
}

window.walkinDateEditPopupInit = () => {
    $('.edit-walkin-date-popup').on('click', function (e) {
        $(this).closest('.package-grid-shortlist').find('.datetimeBlockPopup').show();
    });
}

window.ToggleReadMore = () => {
    var showChar = 100;
    var ellipsestext = "...";
    var moretext = "Read more";
    var lesstext = "Read less";
    $('.school-comment-popup').each(function () {
        var content = $(this).html();

        if (content.length > showChar) {

            var c = content.substr(0, showChar);
            var h = content.substr(showChar - 1, content.length - showChar);

            var html = c + '<span class="moreelipses">' + ellipsestext + '</span>&nbsp;<span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

            $(this).html(html);
        }

    });

    $(".morelink").click(function () {
        if ($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
}

window.distance_condition = (distance) => {
    let initialDist = distance;
    distance = distance.replace("[^\\d.]", "");
    distance = parseFloat(distance);
    if (distance > 500) {
        return `<span>
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            More than 500 Km.
            </span>`;
    } else {
        return `<span>
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            ${initialDist}
            </span>`;
    }
}

window.wishlistModalOpenAnalytics = () => {
    if (!user) return;
    /*axios.get(`${APP_BASE_URL}/home/wishlist-new/server/wishlist-modal-open-analytics.php`).then(res => {
        if (DEBUG) console.log(res);
    }).catch(err => {
        if (DEBUG) console.log(err)
    });*/
}

window.get_board = (school) => {
    if (school.board1 && school.board2) {
        return `<span>` + school.board1 + ", " + school.board2 + `</span>`;
    } else if (school.board1 && school.board2 == null) {
        return `<span>` + school.board1 + `</span>`;
    } else if (school.board1 == null && school.board2) {
        return `<span>` + school.board2 + `</span>`;
    } else {
        return `<span> N/A </span>`;
    }
};

window.get_fee_with_unit = (school) => {

    let {fees = null, yearly_fees2 = null} = school;
    const {typeid: school_type_id = "1"} = school;
    let feesText = fees;

    if (parseInt(school_type_id) === 2 && !!fees) {
        fees = Math.ceil(fees / 12);
        feesText = parseFloat(parseInt(fees).toFixed(2));
    }

    if ([3, 4].includes(parseInt(school_type_id)) && !!yearly_fees2) feesText = yearly_fees2;

    feesText = indianPriceFormat(feesText);
    if (([3, 4].includes(parseInt(school_type_id)) && !yearly_fees2)) feesText = null;
    return feesText ? `AED ${feesText}` : "N/A";

};

window.indianPriceFormat = (price) => {
    price = price.toString();
    let lastThree = price.substring(price.length - 3);
    let otherNumbers = price.substring(0, price.length - 3);
    if (otherNumbers !== '') lastThree = ',' + lastThree;
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
}

window.removeWishlist = (school_id, callback) => {
    if (!user) {
        openLoginModal();
        return;
    }
    let formData = new FormData();
    formData.append('schId', school_id);
    formData.append('toggle', 0);
    mainApiAxios.post(`/shortlist-toggle`, formData).then(res => {
        let responseData = res.data;
        if (responseData.code === 'CREATED' || responseData.code === 'OK') {
            return callback(true);
        } else {
            return callback(false);
        }
    }).catch(err => console.log(err));
}

window.addWishlist = (schoolId, callback) => {
    if (!user) {
        openLoginModal();
        return;
    }
    let formData = new FormData();
    formData.append('schId', schoolId);
    formData.append('toggle', 1);
    mainApiAxios.post(`/shortlist-toggle`, formData).then(res => {
        let responseData = res.data;
        if (responseData.code === 'CREATED' || responseData.code === 'OK') {
            ga('send', 'event', {
                eventCategory: 'Wishlist',
                eventAction: 'Wishlist Added',
                eventLabel: 'Wishlist Added Success'
            });
            return callback(true);
        } else {
            return callback(false);
        }
    }).catch(err => console.log(err));
}

$(function () {

    $('body').on('click', '.shortlist-school', function (e) {
        e.preventDefault();
        let shortlistSchoolEle = $(this);
        let schoolId = shortlistSchoolEle.attr('data-school');

        if (shortlistSchoolEle.hasClass('wishlisted')) {
            removeWishlist(schoolId, function (status) {
                if (!status) return;
                shortlistSchoolEle.removeClass('wishlisted');
                shortlistSchoolEle.find('i').addClass('fa-regular').removeClass('fa-solid');
                loadWishlist();
            })
        } else {
            addWishlist(schoolId, function (status) {
                if (!status) return;
                shortlistSchoolEle.addClass('wishlisted');
                shortlistSchoolEle.find('i').removeClass('fa-regular').addClass('fa-solid');
                loadWishlist();
            })
        }
    });

    loadWishlist()

});

window.updateShortlistIconOnPage = (schoolIds) => {
    $('.shortlist-school').removeClass('wishlisted');
    $(`.shortlist-school`).find('i').addClass('fa-regular').removeClass('fa-solid');
    schoolIds.map((s) => {
        let schoolCard = $(`#school${s.school}`);
        let schoolCardClass = $(`.shortlist-school${s.school}`);
        schoolCard.addClass('wishlisted');
        schoolCard.find('i').removeClass('fa-regular').addClass('fa-solid');
        schoolCardClass.find('i').removeClass('fa-regular').addClass('fa-solid');
        schoolCardClass.addClass('wishlisted');
    })
}
